export default "__VITE_ASSET__DLdd9jRg__"